/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class BatchJobConfigurationModel {
        private systemLevel: Wars.Domain.Model.SystemLevel;
        batchJobConfigurations: Array<Wars.Domain.Model.BatchJobConfiguration>;
        batchJobConfiguration: Wars.Domain.Model.BatchJobConfiguration;
        objectQueries: Array<Wars.Domain.Model.ObjectQuery>;
        processActions: Array<Wars.Domain.Model.ProcessAction>;
        systemActions: Array<Wars.Domain.Model.SystemAction>;
        timeZones: Wars.Domain.Model.Dtos.TimeZoneDto[];
        showEdit: boolean;
        isNewBathJob: boolean;

        constructor(
            private scope: angular.IScope,
            private growlService: angular.growl.IGrowlService,
            private batchJobConfigurationService: services.BatchJobConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService,
            private objectQueryService: services.ObjectQueryService,
            private processActionService: services.ProcessActionService,
            private treeService: services.TreeService,
            private queryConfigurationService: services.QueryConfigurationService,
            private timeZoneService: services.TimeZoneService,
            private processConfigurationId: string)
        {
            this.processConfigurationId = processConfigurationId;

            if (this.processConfigurationId) {
                batchJobConfigurationService.getBatchJobConfigurationsByProcess(this.processConfigurationId)
                    .then(b => {
                        this.batchJobConfigurations = b;
                    });
                objectQueryService.getAllObjectQueriesForProcessConfiguration(this.processConfigurationId)
                    .then(objectQueries => {
                        this.objectQueries = Enumerable.from(objectQueries).where(i => i.isExecutable).toArray();
                    });
                processActionService.getAllProcessActions(this.processConfigurationId)
                    .then((processActions) => {
                        this.processActions = processActions;
                    });
            } else {
                systemLevelService.getSystemLevelBatchJobs()
                    .then(systemLevel => {
                        this.systemLevel = systemLevel;
                        this.batchJobConfigurations = systemLevel.myBatchJobConfigurations;
                    });
                objectQueryService.getAllObjectQueriesForSystemLevel()
                    .then(objectQueries => {
                        this.objectQueries = objectQueries;
                    });
                systemLevelService.getSystemLevelSystemActions()
                    .then((systemLevel) => {
                        this.systemActions = systemLevel.mySystemActions;
                    });
            }

            this.timeZoneService.getValidServerTimeZones()
                .then(timeZones => {
                    this.timeZones = timeZones;
                });
        }

        addBatchJob() {
            var newBatchJobConfiguration = this.batchJobConfigurationService.createBatchJobConfiguration();
            newBatchJobConfiguration.isRecurring = false;
            if (this.processConfigurationId) {
                newBatchJobConfiguration.processConfiguration_id = this.processConfigurationId;
            } else {
                newBatchJobConfiguration.systemLevel_id = this.systemLevel.id;
            }
            newBatchJobConfiguration.uniqueIdentifier = services.UtilityService.generateGuidComb();
            this.batchJobConfigurationService.saveAllChanges(() => {
                this.batchJobConfigurations.push(newBatchJobConfiguration);
                this.batchJobConfiguration = newBatchJobConfiguration;
                this.showEdit = true;
                this.isNewBathJob = true;
            });
        }

        editBatchJobConfiguration(batchJobConfiguration: Wars.Domain.Model.BatchJobConfiguration) {
            this.batchJobConfiguration = batchJobConfiguration;
            this.showEdit = true;
            this.isNewBathJob = false;
        }

        removeBatchJobConfiguration(batchJobConfiguration: Wars.Domain.Model.BatchJobConfiguration) {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "BatchJobConfiguration",
                batchJobConfiguration.id,
                "Successfully delete Batch Job Configuration",
                () => {
                    this.batchJobConfigurations.remove(batchJobConfiguration);
                    this.showEdit = false;
                },
                "Could not delete Batch Job Configuration");
        }

        recurringChange() {
            if (this.batchJobConfiguration.isRecurring === false) {
                this.batchJobConfiguration.interval = null;
            }
            this.saveChanges();
        }

        getTreeItemName(treeItem: Wars.Domain.Model.TreeItem): string {
            if (!treeItem) return '';
            return this.treeService.getDisplayName(treeItem);
        }

        onDropTreeItem($event, batchJobConfigurationParameter: Wars.Domain.Model.OperationParameter) {
            var treeItem = this.treeService.createTreeItemFromItemDropped();

            batchJobConfigurationParameter.treeItem = treeItem;
            batchJobConfigurationParameter.treeItem_id = treeItem.id;
            this.saveChanges();
        }

        selectProcessCandidatesQuery() {
            if (this.batchJobConfiguration.parameters.length > 0) {
                this.batchJobConfiguration.parameters.forEach(parameter => {
                    parameter.entityAspect.setDeleted();
                });
            }
            if (this.batchJobConfiguration.myObjectQuery.myInputObjectSchema &&
                this.batchJobConfiguration.myObjectQuery.myInputObjectSchema.properties) {
                this.batchJobConfiguration.myObjectQuery.myInputObjectSchema.properties
                    .forEach(property => {
                        var queryParameter = this.queryConfigurationService.createNewQueryParameter();
                        queryParameter.name = property.name;
                        this.batchJobConfiguration.parameters.push(queryParameter);
                    });
            }
            this.saveChanges();
        }

        saveChanges() {
            this.batchJobConfigurationService.saveAllChanges();
        }

        close() {
            this.showEdit = false;
        }
    }
}